/* 趙雲傳共用的小工具：史書上有名但不是可選武將的人、各方的兵、帶一隊兵、不交戰的人（劇情用）
 * （只給 zhaoyun*.ts 用；機制寫在這裡，不動 campaign/kit.ts） */
// @ts-nocheck
import { SG } from '../../core/sg.ts';
import { H } from '../../heroes/define.ts';
import { troop, TROOPS } from '../kit.ts';

export const SHU = TROOPS.shu, WEI = TROOPS.wei, WU = TROOPS.wu;
export const GUI = troop('zy-guiyang', '桂陽郡兵', { armor: '#6a5a3a', sleeve: '#4a3e2a', cloth: '#4a3e2a', plume: '#b09050' }); // 趙範的部曲

// 不是可選武將的人：通用招式，n 是招式傷害（中立的人墊一套暗色的底）
const NEUTRAL_C = { armor: '#5a4a3a', sleeve: '#3a3028', cloth: '#3a3028', trim: '#b8a060', pants: '#2a2420', boot: '#2a2018', cape: null, belt: '#5a3a22', metal: '#8e979f', hood: '#3a3028', pole: '#5a3a22', plume: '#b8a060', band: '#b8a060' };
const P = (id, name, sub, faction, role, weapon, look, n) => H(id, name, sub, faction, role, weapon, Object.assign({ fx: '#ffd8a0' }, look, faction === 'neutral' ? { c: Object.assign({}, NEUTRAL_C, look.c) } : {}), [
  ['揮擊', 'crescent', `造成 {${n}/${n}/${n}/${n}} 傷害。`], ['衝陣', 'charge', `衝撞造成 {${n}/${n}/${n}/${n}} 傷害。`], ['迴斬', 'spin', `每圈 {${n >> 1}/${n >> 1}/${n >> 1}/${n >> 1}} 傷害。`], ['猛擊', 'slam', `{${n * 1.5}/${n * 1.5}/${n * 1.5}} 傷害。`]]);
export const MEN = {
  xiahoulan: P('zy-xiahoulan', '夏侯蘭', '趙雲同鄉', 'wei', '戰士', 'spear', { beard: 'mustache' }, 70),
  zhaofan: P('zy-zhaofan', '趙範', '桂陽太守', 'neutral', '謀士', 'staff', { head: 'guan', beard: 'goatee', c: { armor: '#6a5a3a', cloth: '#4a3e2a', plume: '#b09050' } }, 30),
  wujiang: P('zy-wujiang', '吳將', '孫夫人的吏兵', 'wu', '戰士', 'sword', { beard: 'bushy', bulk: 1.1 }, 70),
  dengzhi: P('zy-dengzhi', '鄧芝', '字伯苗', 'shu', '戰士', 'bow', { beard: 'goatee', ranged: true }, 60),
};

// 帶一隊兵：n 個跟著 lead 走的兵（spec 換成那一方的兵）
export function band(m, lead, n, name, spec, o) {
  return Array.from({ length: n }, (_, i) => {
    const u = m.recruit(lead.x - 80 - (i % 4) * 50, lead.y - 70 + Math.floor(i / 4) * 80, name);
    u.spec = spec || SHU; Object.assign(u, o || {}); if (o && o.hp) u.maxHp = o.hp;
    m.join(u, lead);
    return u;
  });
}

// 不交戰的人（劇情用）：中立、打不到、不出手，靠 home 走路
export function npc(w, spec, x, y, o) {
  const [px, py] = SG.MAP.walkable(x, y, SG.MAP.BODY) ? [x, y] : SG.MAP.nearestFree(x, y);
  const u = SG.unit(Object.assign({ kind: 'creep', spec, team: 2, x: px, y: py, home: [px, py], f: -1, r: 24, hp: 1000, maxHp: 1000, atk: 0, armor: 0, asp: 100, ms: 220, range: 60,
    gold: 0, xp: 0, name: spec.name, think: 0, untargetable: true }, o || {}));
  w.units.push(u);
  return u;
}

// 選擇：在幾個地點各立一個標記，走過去站定讀條就選了那一個（fn(key)）
export function choose(m, w, opts, fn) {
  const V = m.vars;
  V.choice = { opts, fn, picked: null };
  for (const o of opts) m.mark('ch-' + o.key, o.x, o.y, o.label, true);
}
export function chooseTick(m, w) {
  const C = m.vars.choice, me = w.player;
  if (!C || C.picked) return;
  for (const o of C.opts) m.chanAt(me, 'ch-' + o.key, o.x, o.y, 110, 1.5, o.label, () => {
    if (C.picked) return;
    C.picked = o.key;
    for (const p of C.opts) m.unmark('ch-' + p.key);
    C.fn(o.key);
  });
}
